module.exports = __webpack_public_path__ + "ef2c68925ad1f71167015be5d904c133.jpg";